import { Component, Input } from '@angular/core';

import { DoodProductModel } from '@core/models/product.model';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product';

@Component({
  selector: 'app-marketplace-category-vertical-two-levels',
  templateUrl: './marketplace-category-vertical-two-levels.component.html',
  standalone: false,
})
export class MarketplaceCategoryVerticalTwoLevelsComponent {
  @Input() displayContext = '';
  @Input() id?: string;
  @Input() title?: string;
  @Input() heading?: string;
  @Input() categories: {
    id: string;
    heading?: string;
    title?: string;
    products: DoodProductModel[];
  }[] = [];
  @Input({ required: true }) tagColors!: ContentBuilderFieldColors;

  private readonly store = inject(Store);

  protected requestGoToProduct(product: DoodProductModel, categoryId: string): void {
    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: product.shop_id,
        productOrigin: {
          channel: 'catalog',
          reference: `category_${categoryId}`,
        },
      }),
    );
  }
}
